const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogProfissional(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogProfissional`, params);
    },
    $obterRelatorioLogCSVProfissional(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogProfissionalCsv`, params);
    },
    $obterRelatorioLogPDFProfissional(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogProfissionalPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
